import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _excluded = ["renderTemplates"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import classNames from "classnames";
import get from "lodash/get";
import React from "react";
import { getQliticsSchema } from "../utils";
import { Link } from "./link";
import { ResponsiveImage } from "./responsive-image";
import StoryElementDailyMotion from "./story-elements/dailymotion";
import JSEmbed from "./story-elements/jsembed";
import Polltype from "./story-elements/polltype";
import { Table } from "./story-elements/table";
import StoryElementYoutube from "./story-elements/youtube";
/**
 * This component renders different types of [story elements](https://developers.quintype.com/malibu/terminology#story-elements)

 * Qlitics event is fired on story-elements become visible (this can be disabled by passing a prop called `disableAnalytics={true}`)
 *
 * Example
 * ```javascript
 * import { StoryElement } from '@quintype/components';
 * function StoryCard(props){
 *   return <div>
 *     {props.card['story-elements'].map((element, index) => <StoryElement element={element} key={index} story={props.story}></StoryElement>)}
 *   </div>
 * }
 * ```
 * For different quality images in Image Story Element, pass `imageWidths` and `imageDefaultWidth` as props
 * ```javascript
 * <StoryElement story={story} element={element} imageWidths={[420,1040,1600]} imageDefaultWidth={1040}/>
 * ```
 *
 * FIXME: the templates property will allow you to pass in a custom template to override the story elements type.
 *
 * @component
 * @hideconstructor
 * @category Story Page
 */

export var StoryElement = /*#__PURE__*/function (_React$Component) {
  _inherits(StoryElement, _React$Component);

  var _super = /*#__PURE__*/_createSuper(StoryElement);

  function StoryElement(props) {
    var _this;

    _classCallCheck(this, StoryElement);

    _this = _super.call(this, props);
    _this.state = {
      crashed: false
    };
    return _this;
  }

  _createClass(StoryElement, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, stack) {
      this.setState({
        crashed: true,
        error: error
      });
      console && console.error("Caught Exception: ".concat(error && error.message));
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.crashed) {
        return /*#__PURE__*/React.createElement("div", {
          className: "story-element story-element-crashed"
        });
      } else {
        return /*#__PURE__*/React.createElement(StoryElementBase, this.props);
      }
    }
  }]);

  return StoryElement;
}(React.Component);

function StoryElementText(_ref) {
  var _ref$element = _ref.element,
      element = _ref$element === void 0 ? {} : _ref$element,
      externalLink = _ref.externalLink;
  var text = element.text || "";

  if (externalLink) {
    text = element.text.replace(/<a/g, '<a target="_blank"');
  }

  return /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: text
    }
  });
}

function StoryElementAlsoRead(_ref2) {
  var element = _ref2.element,
      story = _ref2.story,
      _ref2$alsoreadText = _ref2.alsoreadText,
      alsoreadText = _ref2$alsoreadText === void 0 ? "Also Read: " : _ref2$alsoreadText;
  var linkedStories = get(story, ["linked-stories"]);
  var linkedStoryId = get(element, ["metadata", "linked-story-id"]);
  var linkedStorySlug = get(linkedStories, [linkedStoryId, "slug"]);
  var storyUrl = "/".concat(linkedStorySlug);
  var linkProps = {
    className: "story-element-text-also-read__link",
    href: storyUrl
  };
  return /*#__PURE__*/React.createElement("h3", {}, /*#__PURE__*/React.createElement("span", {
    className: "story-element-text-also-read__label"
  }, alsoreadText), /*#__PURE__*/React.createElement(Link, linkProps, element.text));
}

function StoryElementImage(_ref3) {
  var element = _ref3.element,
      _ref3$story = _ref3.story,
      story = _ref3$story === void 0 ? {} : _ref3$story,
      imageWidths = _ref3.imageWidths,
      imageDefaultWidth = _ref3.imageDefaultWidth,
      _ref3$onClick = _ref3.onClick,
      onClick = _ref3$onClick === void 0 ? function () {} : _ref3$onClick;
  return /*#__PURE__*/React.createElement("figure", {}, /*#__PURE__*/React.createElement(ResponsiveImage, {
    slug: element["image-s3-key"],
    metadata: element["metadata"],
    aspectRatio: null,
    defaultWidth: imageDefaultWidth || 640,
    widths: imageWidths || [360, 640, 1200],
    imgParams: {
      auto: ["format", "compress"]
    },
    alt: element.title || story.headline,
    onClick: onClick
  }), /*#__PURE__*/React.createElement("div", {
    className: "story-element-caption-attribution-wrapper"
  }, element.title ? /*#__PURE__*/React.createElement("figcaption", {
    dangerouslySetInnerHTML: {
      __html: element.title
    },
    className: "story-element-image-title"
  }) : undefined, element["image-attribution"] ? /*#__PURE__*/React.createElement("figcaption", {
    dangerouslySetInnerHTML: {
      __html: element["image-attribution"]
    },
    className: "story-element-image-attribution"
  }) : undefined));
}

function StoryElementTitle(_ref4) {
  var element = _ref4.element;
  return /*#__PURE__*/React.createElement("h2", {}, element.text);
}

function StoryElementSoundCloud(_ref5) {
  var element = _ref5.element;
  return /*#__PURE__*/React.createElement("iframe", {
    src: element["embed-url"],
    width: "100%"
  });
}

function StoryElementJsembed(_ref6) {
  var element = _ref6.element;
  return /*#__PURE__*/React.createElement(JSEmbed, {
    embedJS: element["embed-js"],
    id: element["id"]
  });
}

function StoryElementPolltype(_ref7) {
  var element = _ref7.element;
  return /*#__PURE__*/React.createElement(Polltype, {
    id: element["polltype-id"]
  });
}

function StoryElementTable(_ref8) {
  var element = _ref8.element;
  return /*#__PURE__*/React.createElement(Table, {
    id: element.id,
    data: element.data,
    hasHeader: element.metadata["has-header"]
  });
}

function StoryElementFile(_ref9) {
  var element = _ref9.element;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "story-element-file__title"
  }, element["file-name"]), /*#__PURE__*/React.createElement("a", {
    className: "story-element-file__link",
    href: element.url,
    download: true
  }, "download"));
} // FIXME MISSING: composite
// TODO: Can also support various subtypes (though not needed potentially)


var DEFAULT_TEMPLATES = {
  text: StoryElementText,
  image: StoryElementImage,
  title: StoryElementTitle,
  "dailymotion-video": StoryElementDailyMotion,
  "youtube-video": StoryElementYoutube,
  "soundcloud-audio": StoryElementSoundCloud,
  jsembed: StoryElementJsembed,
  polltype: StoryElementPolltype,
  table: StoryElementTable,
  "also-read": StoryElementAlsoRead,
  file: StoryElementFile
};

var StoryElementBase = /*#__PURE__*/function (_React$Component2) {
  _inherits(StoryElementBase, _React$Component2);

  var _super2 = /*#__PURE__*/_createSuper(StoryElementBase);

  function StoryElementBase(props) {
    var _this2;

    _classCallCheck(this, StoryElementBase);

    _this2 = _super2.call(this, props);

    _defineProperty(_assertThisInitialized(_this2), "initiateObserver", function () {
      if (_this2.props.disableAnalytics === true) return false;
      var options = {
        root: null,
        rootMargin: "0px",
        threshold: 1.0
      };
      _this2.observer = new IntersectionObserver(_this2.observerCallback, options);

      _this2.observer.observe(_this2.storyElementRef);
    });

    _defineProperty(_assertThisInitialized(_this2), "destroyObserver", function () {
      _this2.observer && _this2.observer.disconnect();
    });

    _defineProperty(_assertThisInitialized(_this2), "observerCallback", function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          _this2.emitElementQlitics();
        }
      });
    });

    _this2.observer = null;
    _this2.storyElementRef = null;
    return _this2;
  }

  _createClass(StoryElementBase, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.initiateObserver();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.destroyObserver();
    }
  }, {
    key: "template",
    value: function template() {
      var storyElement = this.props.element;
      var templates = Object.assign({}, DEFAULT_TEMPLATES, this.props.templates);
      return templates[storyElement.subtype] || templates[storyElement.type] || "div";
    }
  }, {
    key: "emitElementQlitics",
    value: function emitElementQlitics() {
      var _this$props = this.props,
          _this$props$story = _this$props.story,
          story = _this$props$story === void 0 ? {} : _this$props$story,
          _this$props$card = _this$props.card,
          card = _this$props$card === void 0 ? {} : _this$props$card,
          _this$props$element = _this$props.element,
          element = _this$props$element === void 0 ? {} : _this$props$element;

      if (global.qlitics) {
        global.qlitics("track", "story-element-view", getQliticsSchema(story, card, element));
      } else {
        global.qlitics = global.qlitics || function () {
          (qlitics.q = qlitics.q || []).push(arguments);
        };

        global.qlitics("track", "story-element-view", getQliticsSchema(story, card, element));
      }
    }
  }, {
    key: "storyElement",
    value: function storyElement() {
      return this.props.element;
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames,
          _this3 = this;

      var storyElement = this.props.element;
      var typeClassName = "story-element-".concat(storyElement.type);
      var subtypeClassName = "story-element-".concat(storyElement.type, "-").concat(storyElement.subtype);
      var storyElementTemplate = this.template();

      var _this$props2 = this.props,
          _this$props2$renderTe = _this$props2.renderTemplates,
          renderTemplates = _this$props2$renderTe === void 0 ? {} : _this$props2$renderTe,
          elementProps = _objectWithoutProperties(_this$props2, _excluded);

      var renderTemplate = renderTemplates[storyElement.subtype] || renderTemplates[storyElement.type];
      return /*#__PURE__*/React.createElement("div", {
        className: classNames((_classNames = {
          "story-element": true
        }, _defineProperty(_classNames, typeClassName, true), _defineProperty(_classNames, subtypeClassName, !!storyElement.subtype), _classNames)),
        ref: function ref(_ref10) {
          return _this3.storyElementRef = _ref10;
        }
      }, renderTemplate ? /*#__PURE__*/React.createElement(renderTemplate, _objectSpread({}, elementProps), /*#__PURE__*/React.createElement(storyElementTemplate, Object.assign({}, elementProps))) : /*#__PURE__*/React.createElement(storyElementTemplate, Object.assign({}, elementProps)));
    }
  }]);

  return StoryElementBase;
}(React.Component);

export var STORY_ELEMENT_TEMPLATES = DEFAULT_TEMPLATES;